import React, { useEffect, useState } from 'react';
import calenderIcon from "../../assets/icons/notificationPooling/calendar-02.png";
import { Button, Select } from 'antd';
import { setSelectedFilterType } from '../../features/PoolingNotifications/PoolingNotificationsSlice';
import { notificationList } from '../../features/AutoPooling/AutoPoolingSlice';
import { useDispatch, useSelector } from 'react-redux';

const { Option } = Select;
const NotificationFilters = ({currentPage, setCurrentPage,activeFilter, setActiveFilter,activeDateFilter, setActiveDateFilter,dateFilterOptions }) => {
    const dispatch = useDispatch();
    const { NotificationListData, NotificationActionMessage } = useSelector((state) => state.autoPooling)

    const handleFilterClick = (value) => {
        setActiveFilter(value);
        setSelectedFilterType(value);
    };

    const handleDateFilterChange = (value) => {
        setActiveDateFilter(value);
    };

    return (
        <div className='pooling-notification-filters'>
            <div className='pooling-notification-button-div'>
                {Object.entries(NotificationListData?.tab_count || {}).map(([key, values]) => (
                    <Button
                        key={key}
                        className={`pooling-notification-button ${activeFilter === key ? 'pooling-notification-button-active' : 'pooling-notification-button-not-active'}`}
                        onClick={() => handleFilterClick(key)}
                    >
                        {key.charAt(0).toUpperCase() + key.slice(1)} ({values})
                    </Button>
                ))}
            </div>


            <div className='pooling-notification-dropdown-div' >
                <Select
                    value={activeDateFilter}
                    onChange={handleDateFilterChange}
                    className='pooling-notification-button'
                    style={{ width: 200 }}
                    suffixIcon={
                        <img
                            src={calenderIcon}
                            alt='Calendar Icon'
                            className='calender-icon-pooling'
                        />
                    }
                >
                    {dateFilterOptions.map((filter) => (
                        <Option key={filter.value} value={filter.value}>
                            {filter.label}
                        </Option>
                    ))}
                </Select>
            </div>
        </div>
    );
};

export default NotificationFilters;
